import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Container, EVEntry } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var wrapper = function wrapper(_ref) {
  var colsMobile = _ref.colsMobile,
      colsTablet = _ref.colsTablet,
      colsDesktop = _ref.colsDesktop,
      width = _ref.width;
  return {
    display: 'grid',
    gridTemplateColumns: ["repeat(".concat(colsMobile, ", ").concat(width, "px)"), "repeat(".concat(colsTablet, ", ").concat(width, "px)"), "repeat(".concat(colsDesktop, ", ").concat(width, "px)")],
    justifyContent: 'space-between',
    '> *': {
      my: 'md'
    }
  };
};

var FixedSizeGrid = function FixedSizeGrid(_ref2) {
  var entries = _ref2.entries,
      colsMobile = _ref2.colsMobile,
      colsTablet = _ref2.colsTablet,
      colsDesktop = _ref2.colsDesktop,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 100 : _ref2$width;
  return _jsx(Container, {
    children: _jsx("div", {
      sx: wrapper({
        colsMobile: colsMobile,
        colsTablet: colsTablet,
        colsDesktop: colsDesktop,
        width: width
      }),
      children: entries.map(function (entry, key) {
        return _jsx(EVEntry, _objectSpread(_objectSpread({}, entry), {}, {
          width: width
        }));
      }, this)
    })
  });
};

export default FixedSizeGrid;
//# sourceMappingURL=fixed-size-grid.js.map